import gql from 'graphql-tag'

export const USER_QUERY = gql`
  query user($login: String!) {
    currentUser {
      login
      learningLanguage {
        code
        name
        localizedName
      }
    }
    profile(login: $login) {
      name
      login
      location
      avatarUrl
      fluentLanguages {
        code
        name
        localizedName
      }
      tutor {
        approvedLanguages {
          code
          name
          localizedName
        }
        isFavorite
        isBlocked
        countOfCompletedLiveLessons
      }
      community {
        aboutMe {
          url
          cooked
        }
        badges {
          name
          icon
          image
          url
          description
        }
        recentDiscussions {
          title
          url
          lastPostedAt
          categoryName
          categoryLogo
        }
      }
    }
  }
`

export const UPDATE_USER_MUTATION = gql`
  mutation updateUser(
    $name: String!
    $location: String!
    $avatar: String
    $avatarFileName: String
  ) {
    updateUser(
      user: {
        name: $name
        location: $location
        avatar: $avatar
        avatarFileName: $avatarFileName
      }
    ) {
      name
      location
      avatarUrl
    }
  }
`

export const UPDATE_USER_TUTOR_MUTATION = gql`
  mutation updateUserTutor($login: String!, $userTutor: UserTutor!) {
    updateUserTutor(login: $login, userTutor: $userTutor) {
      tutor {
        isFavorite
        isBlocked
      }
    }
  }
`
